import React from 'react';
import './Stats.css';

const stats = [
  { value: '50+', label: 'Clients Served' },
  { value: '100+', label: 'Projects Delivered' },
  { value: '5+', label: 'Years of Experience' },
  { value: '20+', label: 'Team Members' },
];

function Stats() {
  return (
    <div className="stats-bar">
      {stats.map((stat, index) => (
        <div className="stat-item" key={index}>
          <span className="stat-value">{stat.value}</span>
          <span className="stat-label">{stat.label}</span>
        </div>
      ))}
    </div>
  );
}

export default Stats;
